import styled from 'styled-components'

import { helpers } from 'styles'

export const HeaderIconWrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 16px;
	align-items: center;
	justify-content: center;
	text-align: center;

	margin: ${helpers.spacing.small} -${helpers.spacing.large};
	padding: ${helpers.spacing.xxLarge} ${helpers.spacing.large};
	width: calc(100% + ${helpers.spacing.xxLarge});
`
